/* =========================================================================
   ATELIER HERO: Multiple Slider Engine & Dynamic Variant Image
   ========================================================================= */
document.addEventListener('DOMContentLoaded', function() {
  if (typeof Splide === 'undefined') return;

  // Store instances as objects containing both the slider and its DOM wrapper
  window.heroSplideInstances = [];

  // Find EVERY hero wrapper on the page (desktop and mobile)
  const wrappers = document.querySelectorAll('.atelier-hero-wrapper');

  wrappers.forEach(wrapper => {
    const mainEl = wrapper.querySelector('.js-hero-splide');
    const thumbEl = wrapper.querySelector('.js-hero-thumbnails');
    
    if (!mainEl || !thumbEl) return;

    // 1. Initialize Main Slider
    const mainSplide = new Splide(mainEl, {
      type        : 'loop',
      direction   : 'ltr',
      perPage     : 1,
      gap         : 0,
      arrows      : true,
      pagination  : false,
      drag        : true,
      speed       : 400,
      wheel       : false,
    });

    // 2. Initialize Thumbnail Slider
    const thumbSplide = new Splide(thumbEl, {
      fixedWidth  : 100,    // Adjusted to 100px
      fixedHeight : 100,
      gap         : 10,
      rewind      : true,
      pagination  : false,
      arrows      : false,
      isNavigation: true,
      focus       : 'center',
      dragMinThreshold: { mouse: 4, touch: 10 },
    });

    // 3. Sync and mount
    mainSplide.sync(thumbSplide);
    mainSplide.mount();
    thumbSplide.mount();

    // Push to our global array for the custom event to target
    window.heroSplideInstances.push({
      slider: mainSplide,
      wrapper: wrapper
    });
  });

  // --- THE DYNAMIC IMAGE SWAP LOGIC ---
  // Listen for the custom event broadcasted by atelier-collection.js
  document.addEventListener('Atelier:VariantChanged', function(e) {
    const variantId = e.detail.variantId;

    window.heroSplideInstances.forEach(instance => {
      const wrapper = instance.wrapper;
      const splide = instance.slider;

      // Find the correct image in the hidden bank
      const hiddenImg = wrapper.querySelector(`.js-variant-image-bank img[data-variant-id="${variantId}"]`);
      
      if (hiddenImg) {
        const mainTarget = wrapper.querySelector('.js-main-image-target');
        const thumbTarget = wrapper.querySelector('.js-thumb-image-target');
        
        if (mainTarget) {
          mainTarget.src = hiddenImg.src;
          mainTarget.removeAttribute('srcset'); 
        }
        if (thumbTarget) {
          thumbTarget.src = hiddenImg.dataset.thumb;
          thumbTarget.removeAttribute('srcset');
        }
      }
      
      // Tell Splide to slide back to the first image
      splide.go(0);
    });
  });

});